module.exports = __webpack_public_path__ + "media/images/front/review_star_03-acd404c7a4b254b745cbc8437d7b14f2.png";